const reducedMotionMedia = () => window.matchMedia('(prefers-reduced-motion: reduce)');

const prefersReducedMotion = () => reducedMotionMedia().matches;

export { prefersReducedMotion, reducedMotionMedia }
